import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import ListSuggestCases from './ListSuggestCases'


const SpecialistSuggestCasesRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListSuggestCases /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistSuggestCasesRoutes